const DescripCard = ({cardList}) => {
  return (
    <div className="container">
      <div className="grid grid-cols-12 gap-8">
        {cardList?.map((item) => {
          const { id, icon, desc, itemClass } = item;
          return (
            <div className={`${itemClass} rounded-2.5xl border border-jacarta-100 bg-white p-10 pt-12 transition-shadow hover:shadow-xl dark:border-jacarta-700 dark:bg-[#131740]`} key={id}>
              <div
                className={`mb-6 inline-flex rounded-full p-3 bg-[#1B2157]`}
              >
                <div
                  className={`inline-flex h-12 w-12 items-center justify-center rounded-full bg-accent`}
                >
                  <svg className="icon icon-wallet h-5 w-5 fill-white">
                    <use xlinkHref={`/images/descrip-card.svg#${icon}`}/>
                  </svg>
                </div>
              </div>
              <p className="dark:text-jacarta-300 text-base">{desc}</p>
            </div>
          )
        })}
      </div>
    </div>
  )
};

export default DescripCard;
